"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_common_1 = require("@progress/kendo-react-common");
var FormContext_1 = require("./FormContext");
/**
 * Represents the KendoReact FormElement component.
 * It's small wrapper around HTML form element which automatically attach the
 * Form component's `onSubmit` render prop and Kendo CSS classes.
 * Other props are passed to the DOM node.
 */
exports.FormElement = function (props) {
    var form = React.useContext(FormContext_1.FormContext);
    var className = props.className, onSubmit = props.onSubmit, style = props.style, horizontal = props.horizontal, others = __rest(props, ["className", "onSubmit", "style", "horizontal"]);
    var formClassName = kendo_react_common_1.classNames({
        'k-form': true,
        'k-form-horizontal': horizontal === true
    }, className);
    return (React.createElement("form", __assign({}, others, { style: props.style, className: formClassName, onSubmit: form ? form.onSubmit : undefined }), props.children));
};
exports.FormElement.displayName = 'KendoReactFormElement';
//# sourceMappingURL=FormElement.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-form@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-form/dist/npm/FormElement.js
// module id = 6555
// module chunks = 0